import { CSSProperties, ReactNode } from 'react'
import { iconSizes, Tooltip } from '@common/ui'
import type { Icon as TablerIcon } from '@common/ui/icons'
import type { ActionAccessInfo } from './utils'

type ActionIconIndicatorProps = {
  Icon: TablerIcon
  access: ActionAccessInfo | undefined
  iconStyle?: CSSProperties
  muted?: boolean
  tooltip?: ReactNode
  policyNames?: readonly string[]
}

const ActionIconIndicator = ({
  Icon,
  access,
  iconStyle,
  muted = false,
  tooltip,
  policyNames,
}: ActionIconIndicatorProps) => {
  if (!access || access.total === 0)
    return <span style={{ width: 20, height: 20, display: 'inline-flex', verticalAlign: 'middle' }} />
  const iconColor = muted ? 'var(--trellis-color-text-disabled)' : 'var(--trellis-color-text-primary)'
  const showCount = !(access.total === 1 && access.all === 1)

  const indicator = (
    <span
      style={{
        position: 'relative',
        width: 20,
        height: 20,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
      }}
    >
      <Icon size={iconSizes.sm} stroke={1.5} style={{ color: iconColor, ...iconStyle }} />
      {policyNames && policyNames.length > 0 ? (
        <span
          style={{
            position: 'absolute',
            left: -3,
            top: -2,
            width: 6,
            height: 6,
            borderRadius: '50%',
            backgroundColor: 'var(--trellis-color-accent)',
          }}
        />
      ) : null}
      {showCount ? (
        <span
          style={{
            position: 'absolute',
            right: -3,
            top: -2,
            backgroundColor: muted ? 'var(--trellis-color-text-disabled)' : 'var(--trellis-color-error)',
            color: 'var(--trellis-color-on-error)',
            fontSize: 8,
            fontWeight: 700,
            lineHeight: 1,
            width: 12,
            height: 12,
            borderRadius: '50%',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {access.total}
        </span>
      ) : null}
    </span>
  )

  if (!tooltip) return indicator
  return (
    <Tooltip label={tooltip} withArrow position="top">
      {indicator}
    </Tooltip>
  )
}

export default ActionIconIndicator
